<template>
    <div class="cards-container">
        <div class="card" v-for="(card, index) in cards" :key="index">
            <div class="card-header">
                <span>{{ card.label }}</span>
            </div>
            <div class="card-value">{{ card.value }}</div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, watch, defineProps, defineExpose, computed } from 'vue';

const resumenData = ref([]);

const props = defineProps({
    fecha_inicio: String,
    fecha_fin: String
});

const today = new Date().toISOString().split('T')[0];
const fechaInicio = computed(() => props.fecha_inicio || today);
const fechaFin = computed(() => props.fecha_fin || today);

const cards = ref([
    { label: 'Total de KMS', value: '0 KMS' },
    { label: 'Total Fact Sin Casetas', value: '$0.00' },
    { label: 'Total Fact Sin Casetas / Total de KMS', value: '0.00' }
]);

const fetchData = async () => {
    try {
        // console.log(`Consultando API con fechas: ${fechaInicio.value} - ${fechaFin.value}`);
        const response = await fetch(`https://api-wmdata.fmce.com.mx/api/reports/resumen?fecha_inicio=${fechaInicio.value}&fecha_fin=${fechaFin.value}`, {
            method: 'GET'
        });
        const data = await response.json();
        const resumen = data.resumen || {};

        // Asignar valores predeterminados en caso de que sean null o undefined
        const totalKms = resumen.total_kms ?? 0;
        const totalFactSinCasetas = resumen.total_fact_sin_casetas ?? 0;
        const totalFactSinCasetasPorKm = resumen.total_fact_sin_casetas_por_km ?? 0;

        resumenData.value = [{
            total_kms: totalKms,
            total_fact_sin_casetas: totalFactSinCasetas,
            total_fact_sin_casetas_por_km: totalFactSinCasetasPorKm
        }];

        cards.value[0].value = `${formattedNumber(totalKms)} KMS`;
        cards.value[1].value = `$${formattedNumber(totalFactSinCasetas)}`;
        cards.value[2].value = `${formattedNumber(totalFactSinCasetasPorKm)}`;
    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }
};

const formattedNumber = (value) => {
    return new Intl.NumberFormat('es-MX').format(value);
};


onMounted(fetchData);

const getData = () => resumenData.value;

defineExpose({ getData, fetchData });
// Observar cambios en las fechas y actualizar datos
watch([fechaInicio, fechaFin], fetchData);
</script>

<style scoped src="../styles/cardsResumeFact.css"></style>
